import { Box, Button, styled, Typography } from '@mui/material';

export const StyledReplaceButton = styled(Button)(
  ({ theme }) => `
    border-bottom: 2px solid ${theme.palette.primary.main};
    background-color: ${theme.palette.primary.light};
  `,
);

export const StyledTypography = styled(Typography)(
  ({ theme }) => `
    color: ${theme.palette.primary.main};
  `,
);

export const ImagePreview = styled(Box)`
  padding: 8px;
`;
